import { JSX } from "react";
import "../../App.css";
import Sidebar from "../../Components/Layout/Sidebar/Sidebar";
import { appContext } from "../../AppContext";
import { IbssPage } from "../../Components/Core/BasePage/IbssPage";
import "./Styles.scss";

class NoRights extends IbssPage<IProps, IState>
{
    private labels = appContext().labels;

    public componentDidMount(): void
    {
        this.pageTitle = '';
    }

    public render(): JSX.Element
    {
        return (
            <div className="page-container" >
                <Sidebar {...this.props} />
                <div className="rightPanel">
                    <div className="redirectContainer">
                        <div className="card">{this.labels.HubLabelNoRights}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NoRights;

export interface IProps { }
export interface IState { }
